import { useState } from "react";
import { Button, Alert } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { toggleStatus } from "../../../store/actions/conditionsAction";
import ApiResponsePopup from "../../common/modal/ApiResponsePopup";
import Popup from "../../common/modal/Popup";
const ToggelActivatateClientPopup = ({toggleActivateRec, toggleActivateStatus, onHide, toggleActivateModalShow, setToggleActivateModalShow}) => {
    
    const [isAction, setIsAction] = useState(false)
    const [isDone, setIsDone] = useState(false)
    const dispatch = useDispatch();
    const {
        isRecordAdded,
        isRecordUpdated,
        error: apiError
    } = useSelector(state => state.clients);

    const submitHandler = (mode) => {
        setIsAction(true);
        return dispatch(toggleStatus({
                conditionId: toggleActivateRec,
            })).then(() => {
                setIsDone(true);
                onHide()
                setToggleActivateModalShow(false)
            })
    }

    const hideHandlerRes = () => {
        setIsAction(false)
        setIsDone(false)
    }

    return (
        <>
            <Popup
                onHide={() => onHide()}
                size="md"
                show={toggleActivateModalShow}
                title={toggleActivateStatus==='Active'?"Deactivate Condition":"Activate Condition"}
                footer={
                    <>
                        <Button variant="outline-secondary model-btn" className="me-4" onClick={(e) => onHide()}>Cancel</Button>
                        <Button className='btn-primary' onClick={(e) => submitHandler()}>Confirm</Button>
                    </>
                }
            >
                {
                    apiError &&
                    <Alert variant={'danger'}>
                        {apiError?.message || 'Access denied! Please try again'}
                    </Alert>
               }
                <div style={{textAlign: "center"}}>
                    {
                        toggleActivateStatus==='Active'? "Are you sure you want to deactivate this condition?":"Are you sure you want to activate this condition?"
                    }
                </div>
            </Popup>
            {
            isAction &&
            <ApiResponsePopup
                {
                    ...{
                        hideHandlerRes,
                        isRecordUpdated: isDone,
                        title: toggleActivateStatus==='Active'?"Deactivate Condition":"Activate Condition",
                        successMsg: toggleActivateStatus==='Active'?'Condition deactivated successfully!': 'Condition activated successfully!',
                    }
                }
            />
        }
        </>
    )
}

export default ToggelActivatateClientPopup;